export class M3TrimTypeRequest{
    trimType:string;

    constructor(trimType:string){
        this.trimType = trimType
    }
}